import template from './search-input.html';

class SearchInputController {
  constructor($timeout) {
    'ngInject';
    this.$timeout = $timeout;
  }

  triggered() {
    this.ngModel = (this.ngModel || '').trim();
    this.$timeout(this.onTrigger, 1);
  }

  changed() {
    this.ngModel = (this.ngModel || '').trimStart();
    this.$timeout(this.onChange, 1);
  }

  clearSearch() {
    this.ngModel = '';
    this.triggered();
  }
}

export default {
  template,
  controller: SearchInputController,
  controllerAs: 'vm',
  bindings: {
    onTrigger: '&',
    onChange: '&',
    placeHolder: '@',
    size: '@',
    ngModel: '=',
  },
};
